<template>
  <div class="dialog-body">
    <el-dialog title="项目作废确认" :visible.sync="dialogVisible" append-to-body width="50%">
      <div class="result">
        <el-row :gutter="24">
          <el-col :span="24">
            <span style="text-align: center; display: block"
              >订单作废后将无法进行转化为合同，是否确定要作废此项目?</span
            >
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-form
            :model="dialogData"
            :rules="rules"
            ref="dialogForm"
            label-width="150px"
            style="margin-top: 20px"
          >
            <el-form-item label="项目失败原因" prop="reason">
              <el-select
                v-model="dialogData.reason"
                placeholder="请选择"
                label=""
                style="width: 100%"
              >
                <el-option
                  v-for="(item, index) in revokeReasons"
                  :label="item.label"
                  :value="item.value"
                  :key="index"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSure">确认作废</el-button>
        <el-button @click="handleClose">{{ $t('cooperation.buttons.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: 'ProjectRevokeDialog',
    data() {
      return {
        dialogVisible: false,
        revokeReasons: [
          { label: '主动放弃', value: '主动放弃' },
          { label: '公司撤资', value: '公司撤资' },
        ],
        dialogData: { reason: null },
        rules: {
          reason: [
            {
              required: true,
              message: '请选择',
              trigger: ['blur', 'change'],
            },
          ],
        },
      };
    },
    methods: {
      openDialog() {
        this.dialogVisible = true;
      },
      handleClose() {
        this.dialogVisible = false;
      },
      handleSure() {
        this.$refs['dialogForm'].validate((valid) => {
          if (valid) {
            this.dialogVisible = false;
            this.$emit('handleSure', this.dialogData.reason);
          }
        });
      },
    },
  };
</script>

<style scoped>
  ::v-deep .el-dialog__footer {
    text-align: center;
  }

  .el-dialog .el-dialog__body {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .dialog-body {
    display: flex;
    justify-content: center;
    flex-direction: column;
  }

  .result {
    padding: 20px 100px 20px 100px;
  }

  ::v-deep .el-dialog__footer {
    text-align: center;
  }
</style>
